import type { Pinia } from 'pinia'

export default defineNuxtPlugin((nuxtApp) => {
  const pinia = nuxtApp.$pinia as Pinia
  return {
    provide: {
      store: {
        main: useMainStore(pinia),
        user: useUserStore(pinia)
      }
    }
  }
})